import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, QueryList, ViewChildren } from '@angular/core';
import { PopupReportHistorialService } from '../../../../../sections/locations-section/services/Popup-Report-Historial.service';
import * as Sentry from '@sentry/angular';
import { IRouteMapRequest } from '../../../../../sections/route-section/models/IRouteMapRequest';
import { GeoClustersFrecuencyPlacesService } from '../../../../../sections/locations-section/services/GeoClustersFrecuencyPlaces.service';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { GeofencesService } from 'src/app/features/map-features/sections/geofences-section/services/Geofences.service';
import { LocationDTO } from 'src/app/features/map-features/sections/locations-section/models/LocationDTO';
import { PanelDetailLocationsService } from 'src/app/features/map-features/sections/locations-section/services/Panel-Detail-Locations.service';
import { PanelLocationsService } from 'src/app/features/map-features/sections/locations-section/services/Panel-Locations.service';
import { ValetParkingService } from 'src/app/features/map-features/sections/locations-section/services/ValetParking.service';
import { GroupStepRouteDTO } from 'src/app/features/map-features/sections/route-section/models/GroupStepRouteDTO';
import { ResumeRouteMapDTO } from 'src/app/features/map-features/sections/route-section/models/ResumeRouteMapDTO';
import { StepDetailsRouteDTO } from 'src/app/features/map-features/sections/route-section/models/StepDetailsRouteDTO';
import { PanelResumeRouteService } from 'src/app/features/map-features/sections/route-section/services/Panel-Resume-Route.service';
import { RouteFilterService } from 'src/app/features/map-features/sections/route-section/services/Route-Filter.service';
import { RouteMapService } from 'src/app/features/map-features/sections/route-section/services/RouteMap.service';
import { MapHelperService } from 'src/services/map-helper.service';
import { FileUtilities } from '../../../../../../shared/helpers/utilities/FileUtilities';
import { NotificationsToastService } from '../../../../../../shared/services/Notifications-Toast.service';
import { SignalUserService } from '../../../../../../shared/services/ServiceCatalogEncapsulators/Signal-User.service';
import { SessionService } from '../../../../../../shared/services/Session.service';
import { SwalNotificationService } from '../../../../../../shared/services/SwalNotification.service';
import { IRequestMapRouteForm } from '../../models/IRequestMapRouteForm';
import { PermissionFilterPipe } from '../../../../../../shared/pipes/Permission-filter.pipe';
import { LocationsService } from 'src/app/features/map-features/sections/locations-section/services/Locations.service';
import { LocationsMapService } from 'src/app/features/map-features/sections/locations-section/services/LocationsMap.service';
import { environment } from "src/environments/environment";
import { PopupReportHistorialComponent } from '../../../../molecules/popup-report-historial/popup-report-historial.component';
import { AllowedDTO } from 'src/app/features/pages/maps/utils/models/allowedDTO';
import { DetailsPanelAllowanceEnum } from 'src/app/features/pages/maps/utils/enums/detailsPanelAllowanceEnum';
import { MapRestrictionsService } from 'src/app/features/pages/maps/services/MapRestrictions.service';
import { ConfirmDialogService } from 'src/app/features/ui/atoms/dialogs/confirm-dialog/services/Confirm-Dialog.service';
import { ReportLastLocationAllVINsDTO } from 'src/app/features/map-features/sections/locations-section/models/ReportLastLocationAllVINsDTO';
import { ReportsService } from 'src/app/features/shared/services/ServiceCatalogEncapsulators/Reports.service';
import { ExcelUtilities, ReportExcelCellValue } from 'src/app/features/shared/helpers/utilities/ExcelUtilities';

@Component({
  selector: 'app-report-list',
  templateUrl: './report-list.component.html',
  styleUrls: ['./report-list.component.css']
})
export class ReportListComponent implements OnInit,OnDestroy {
  //restricciones
  allowedParts: AllowedDTO;
  isMovementHistoricalAllowed: boolean = false;
  isDriverBehaviorAllowed: boolean = false;
  isDriverStatisticsAllowed: boolean = false;


  @ViewChildren('globalL, lastLocationsAllVINs, movimientosL, conduccionL, manejoL, movimientosR, conduccionR, manejoR') reportList: QueryList<any> = new QueryList();
  @ViewChildren('addGeofence, editGeofence, cloneGeofence, deleteGeofence') geofenceActionList: QueryList<any> = new QueryList();
  @ViewChildren('geoPFrecuencyL') geoprocessActionList: QueryList<any> = new QueryList();
  detailsPanelAllowanceEnum = DetailsPanelAllowanceEnum;

  //inputs para el boton de reportes (default como true)
  @Input() showReportes: boolean = true;
  //inputs para modificar opciones de reportes
  @Input() isRutas: boolean = false;
  @Input() isGlobal: boolean = false;
  @Input() identifier: any;
  @Input() description: any;
  @Input() isFromLocation: boolean = false;

  //inputs para la lista de excel
  @Input() btnDownExcel: boolean = false;
  @Input() isLocationFilter: boolean = false;
  @Input() filterLocationList: LocationDTO[] = [];
  @Input() selectedTabIndex: number;

  //inputs para geocercas
  @Input() editGeofences: boolean = false;
  @Input() isGeofenceDetails: boolean = false;
  @Input() geofenceGuid: string = "";

  //inputs y outputs para el filtro
  @Input() filtersObject: any;
  @Input() ApplyFilter: boolean = false;
  @Output() filterResponse = new EventEmitter<any>();

  //inputs para routes
  locationRequest: IRequestMapRouteForm = {
    vehiculo: undefined,
    startDate: new Date(),
    endDate: new Date(),
  };
  @Input() isDetailLocations: boolean = false;

  //inputs para valet parking
  @Input() isValetParking: boolean = false;
  @Input() valetParkingGuid: string = "";
  @Output() valetParkingDeleteResponse = new EventEmitter<boolean>();
  @Output() valetParkingCreateResponse = new EventEmitter<any>();

  //para mostrar como lista vertical
  @Input() isVerticalList: boolean = false;

  _hasReportsWithPermissions = false;
  subscription_findByIdentifier: Subscription;
  Subscription_AfterClosed: Subscription;
  suscription_openSecondaryMenu: Subscription;
  suscription_getReport: Subscription;
  suscription_getGroupByIdentifier: Subscription;
  suscription_postLocationsToExcel: Subscription;
  suscription_delete: Subscription;
  subscription_routeFilterService: Subscription;
  suscription_valetParkingDelete: Subscription;
  suscription_confirmLastLocationsReport: Subscription;
  suscription_getLastLocationsReport: Subscription;
  showReports : boolean = false;
  groupName: string;

  configDialog: MatDialogConfig = {
    panelClass: "dialog-panel-locations-style",
    disableClose: false,
    height: "fit-content",
    autoFocus: false,
    restoreFocus: false,
    hasBackdrop: false,
  }

  dialogRef = null;

  constructor(private popupReportHistorialService: PopupReportHistorialService,
              private notifyService: SwalNotificationService,
              private notifyToastService: NotificationsToastService,
              private sessionService: SessionService,
              public dialog: MatDialog,
              private panelLocationsService: PanelLocationsService,
              private panelDetalilService: PanelDetailLocationsService,
              private geofenceService : GeofencesService,
              private routeFilterService: RouteFilterService,
              private routeMapService: RouteMapService,
              private panelResumeRouteService: PanelResumeRouteService,
              private mapHelper: MapHelperService,
              private toastrService: ToastrService,
              private signalUserService: SignalUserService,
              private locationsMapService: LocationsMapService,
              private valetParkingService: ValetParkingService,
              public geoClustersFrecuencyCatalogService: GeoClustersFrecuencyPlacesService,
              private permissionFilterPipe: PermissionFilterPipe,
              private mapRestrictionsService: MapRestrictionsService,
              private locationService: LocationsService,
              private confirmDialogService: ConfirmDialogService,
              private reportsService: ReportsService) {
                if(this.sessionService.Customer == undefined || this.sessionService.Customer == null)         
                  this.sessionService.getCustomerId();
              }

  ngOnInit(): void {
    this.calculateRestrictions();
    this.isFromLocation = (!this.isGlobal && !this.isRutas);
    this._hasReportsWithPermissions = this.hasReportsWithPermissions();
  }

  ngOnDestroy(): void{
    if (this.suscription_openSecondaryMenu)
    this.suscription_openSecondaryMenu.unsubscribe();
    if (this.suscription_getReport)
    this.suscription_getReport.unsubscribe();
    if (this.suscription_getGroupByIdentifier)
    this.suscription_getGroupByIdentifier.unsubscribe();  
    if (this.suscription_postLocationsToExcel)
    this.suscription_postLocationsToExcel.unsubscribe();  
    if (this.suscription_delete)
    this.suscription_delete.unsubscribe();  
    if(this.Subscription_AfterClosed)
    this.Subscription_AfterClosed.unsubscribe();
    if(this.subscription_findByIdentifier)
    this.subscription_findByIdentifier.unsubscribe();
    if(this.subscription_routeFilterService)
    this.subscription_routeFilterService.unsubscribe();
    if(this.suscription_valetParkingDelete)
      this.suscription_valetParkingDelete.unsubscribe();
    if(this.suscription_confirmLastLocationsReport)
      this.suscription_confirmLastLocationsReport.unsubscribe();
    if(this.suscription_getLastLocationsReport)
      this.suscription_getLastLocationsReport.unsubscribe();

    this.geoClustersFrecuencyCatalogService.isRecurrentPlacesVisible = false;
    this.geoClustersFrecuencyCatalogService.identifierRecurrentPlaces = "";
    this.geoClustersFrecuencyCatalogService.descriptionRecurrentPlaces = "";

    if(this.dialogRef){
      this.dialogRef.close();
      this.dialogRef = null;
    }
  }

  onClickDownloadReportHistGlobal() {
    
    this.dialogRef = this.dialog.open(PopupReportHistorialComponent, this.configDialog);

    this.dialogRef.afterClosed().subscribe((res) => {
      if(this.sessionService.Customer == undefined || this.sessionService.Customer == null)
        this.sessionService.getCustomerId();
      if (
        res.formGroup.initialDate != undefined &&
        res.formGroup.finalDate != undefined
      ) {
        this.ShowDownloadingMessage();
        
        this.suscription_getReport = this.popupReportHistorialService
          .getReportHist(
            res.formGroup.initialDate,
            res.formGroup.finalDate
          )
          .subscribe({
            next: (response) => {
              if (response.isSuccesful) {
                if(!response.isEmpty && response.file != null)
                {
                FileUtilities.DownLoadFileV2(
                  response.file,
                  "ReporteMovimientosGlobal.xlsx",
                  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                );
                this.notifyService.MessageSuccessful(
                  "Reporte Descargado Exitosamente",
                  "El reporte se encuentra en la carpeta de descargas"
                );
              }else{
                this.notifyService.MessageInfo(
                  "El reporte no contiene información"
                );    
              }
              this.panelLocationsService.setLoading(false);
            }
            },
            error: (error) => {
              // TODO marca para complete despues
              console.error('Error obteniendo el reporte global', error);
              this.panelLocationsService.setLoading(false);
              this.notifyService.MessageInfo("No se encontró información del reporte");
            }
          });
      }
    });
  }

  ShowDownloadingMessage() {
    var resp = this.notifyService.MessageDownloading();
        resp.then(d=>{
        if(d.isConfirmed){
          this.notifyToastService.showInfoExtended("","Procesando solicitud de descarga...");
        }});
  }

  onClickReportLastLocationsAllVINs(){
    this.notifyService.customConfirmMessageInPanel("Reporte de Últimas Ubicaciones", "¿Deseas generar el reporte de últimas ubicaciones de todos los activos? Esta acción puede tardar unos segundos.").then(confirmed => {
      if(!confirmed.value)
        return;

      this.ShowDownloadingMessage();

      this.suscription_getLastLocationsReport = this.reportsService.getReportLocationInventory().subscribe({
          next: (data) => {

            if(!data.isSuccess && data.result == null){
              this.notifyService.MessageInfo("No se encontró información del reporte");
              return;
            }

            const locationsReportData: ReportLastLocationAllVINsDTO[] = data.result;


            if (locationsReportData && locationsReportData.length > 0) {
              this.exportLastLocationsReportToExcel(locationsReportData);
              this.notifyService.MessageSuccessful( "Reporte Descargado Exitosamente", "El reporte se encuentra en la carpeta de descargas" );
            } else {
              this.notifyService.MessageInfo("El reporte no contiene información");
            }
          },
          error: (error) => {
            console.error('Error al obtener el reporte de últimas ubicaciones', error);
            this.notifyService.MessageInfo("No se encontró información del reporte, intente de nuevo más tarde");
          }
        });
        
    });
  }

  exportLastLocationsReportToExcel(rows: ReportLastLocationAllVINsDTO[]) {
    const header = ["VIN", "Contrato", "Coordenadas", "Google Maps", "Última Actualización", "Categoria"];
    const data = rows.map(row => [
      row.vin,
      row.contrato ? row.contrato : "N/A",
      `${ExcelUtilities.max6DecTruncate(row.lat.toString())}, ${ExcelUtilities.max6DecTruncate(row.long.toString())}`,
      ExcelUtilities.getGoogleMapsURL(row.lat, row.long),
      ExcelUtilities.parseDate(row.fechaUltimaActualizacion),
      row.category ? row.category : "N/A"
    ]) as ReportExcelCellValue[][];
    const title = `Reporte Últimas Ubicaciones ${new Date().toISOString().slice(0, 10)}`;

    const cliente = this.sessionService.Customer.description || "Cliente Desconocido";
    
    ExcelUtilities.exportReportExcel(title, header, data, cliente);
  }

  onClickReportMenuHistMov(){
    this.dialogRef = this.dialog.open(PopupReportHistorialComponent, this.configDialog);
    this.dialogRef.afterClosed().subscribe((res) => {
      if(this.sessionService.Customer == undefined || this.sessionService.Customer == null)
        this.sessionService.getCustomerId();
      if (
        res.search &&
        res.formGroup.initialDate != undefined &&
        res.formGroup.finalDate != undefined
      ) {
        this.ShowDownloadingMessage();
        if(!environment.production) console.log("session service",this.sessionService);
        
        this.suscription_getReport = this.popupReportHistorialService
          .getReportHist(
            res.formGroup.initialDate,
            res.formGroup.finalDate,
            this.identifier
          ).subscribe({
            next: (response) => {
              if (response.isSuccesful) {
                if(!response.isEmpty && response.file != null)
                {
                  const name = this.identifier ? this.identifier + "_" : "";
                FileUtilities.DownLoadFileV2(
                  response.file,
                  name + "Reporte Historial de movimientos.xlsx",
                  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                );
                this.notifyService.MessageSuccessful(
                  "Reporte Descargado Exitosamente",
                  "El reporte se encuentra en la carpeta de descargas"
                );
                }else{
                  this.notifyService.MessageInfo(
                    "El reporte no contiene información"
                  );    
                }
              }
              this.panelDetalilService.setLoading(false);
            },
            error: (error) => {
              // TODO marca para complete despues
              console.error('Error al obtener el reporte historial de movimientos', error);
              this.panelDetalilService.setLoading(false);
              this.notifyService.MessageInfo("No se encontró información del reporte" );
            }
          });
        // }
      }
    });
  }
  onClickReportMenuStats(){
    this.dialogRef = this.dialog.open(PopupReportHistorialComponent, this.configDialog);
  
    this.dialogRef.afterClosed().subscribe((res) => {
      if(this.sessionService.Customer == undefined || this.sessionService.Customer == null)
        this.sessionService.getCustomerId();
      if (
        res.search &&
        res.formGroup.initialDate != undefined &&
        res.formGroup.finalDate != undefined
      ) {
        this.ShowDownloadingMessage();
        if(!environment.production) console.log("session service",this.sessionService);
        if(!environment.production) console.log("res",res.formGroup.initialDate);
        if(!environment.production) console.log("res 2",res.formGroup.finalDate);
        if(!environment.production) console.log("identifier",this.identifier);
        
         this.suscription_getReport = this.popupReportHistorialService
          .getReportStatistics(
            res.formGroup.initialDate,
            res.formGroup.finalDate,
            this.identifier
          ).subscribe({
            next: (response) => {
              if (response.isSuccesful) {
                if(!response.isEmpty && response.file != null)
                {
                const name = this.identifier ? this.identifier + "_" : "";
                FileUtilities.DownLoadFileV2(
                  response.file,
                  name + "Reporte estadisticas de manejo.xlsx",
                  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                );
                this.notifyService.MessageSuccessful(
                  "Reporte Descargado Exitosamente",
                  "El reporte se encuentra en la carpeta de descargas"
                );
                }else{
                  this.notifyService.MessageInfo(
                    "El reporte no contiene información"
                  );    
                }
              }
              this.panelDetalilService.setLoading(false);
            },
            error: (error) => {
              // TODO marca para complete despues
              console.error('Error al obtener el reporte de estadisticas', error);
              this.panelDetalilService.setLoading(false);
              this.notifyService.MessageInfo("No se encontró información del reporte");
            }
          });
        // }
      }
    });
  }
  onClickReportMenuHabit(){
    this.dialogRef = this.dialog.open(PopupReportHistorialComponent, this.configDialog);
  
    this.dialogRef.afterClosed().subscribe((res) => {
      if(this.sessionService.Customer == undefined || this.sessionService.Customer == null)
        this.sessionService.getCustomerId();
      if (
        res.search &&
        res.formGroup.initialDate != undefined &&
        res.formGroup.finalDate != undefined
      ) {
        this.ShowDownloadingMessage();

        if(!environment.production) console.log("session service",this.sessionService);
        if(!environment.production) console.log("res",res.formGroup.initialDate);
        if(!environment.production) console.log("res 2",res.formGroup.finalDate);
        if(!environment.production) console.log("identifier",this.identifier);
        
       this.suscription_getReport = this.popupReportHistorialService
          .getReportHabits(
            res.formGroup.initialDate,
            res.formGroup.finalDate,
            this.identifier
          ).subscribe({
            next: (response) => {
              if (response.isSuccesful) {
                if(!response.isEmpty && response.file != null)
                {
                let fileBase64: any = response.file;
                const name = this.identifier ? this.identifier + "_" : "";
                FileUtilities.DownLoadFileV2(
                  fileBase64,
                  name + "Reporte Habitos de conduccion.xlsx",
                  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                );
                this.notifyService.MessageSuccessful(
                  "Reporte Descargado Exitosamente",
                  "El reporte se encuentra en la carpeta de descargas"
                );
                }else{
                  this.notifyService.MessageInfo(
                    "El reporte no contiene información"
                  );    
                }
              }
              this.panelDetalilService.setLoading(false);
            },
            error: (error) => {
              // TODO marca para complete despues
              console.error('Error al obtener el reporte de habitos', error);
              this.panelDetalilService.setLoading(false);
              this.notifyService.MessageInfo("No se encontró información del reporte");
            }
          });
        // }
      }
    });
  }

  // getExcel(){
  //   if (!this.isLocationFilter) {
  //     this. suscription_postLocationsToExcel = this.popupReportHistorialService.postLocationsTabToExcel(this.selectedTabIndex).subscribe((data) =>{
      
  //       if (data.isSuccess == true) {
  //         // Decodificar los datos que trae como string del servidor
  //         const byteCharacters = atob(data.result);
  //         const byteNumbers = new Array(byteCharacters.length);
  //         for (let i = 0; i < byteCharacters.length; i++) {
  //           byteNumbers[i] = byteCharacters.charCodeAt(i);
  //         }
  //         const byteArray = new Uint8Array(byteNumbers);
  
  //         const blob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  //         const url = window.URL.createObjectURL(blob);
  //         const a = document.createElement('a');
  //         a.href = url;
  //         a.download = 'Lista_de_locacion.xlsx'; // Nombre del archivo según sea necesario
  //         document.body.appendChild(a);
  //         a.click();
  //         window.URL.revokeObjectURL(url);
  //         this.notifyService.MessageSuccessful(
  //           "Archivo Descargado",
  //           "Se han descargado los activos en un excel"
  //         );
  //       }
  //       else{
  //         this.notifyService.MessageError(
  //           "Archivo no descargado, No hay datos"
  //         );
  //       }
  //     });
  //   }else{
  //     this. suscription_postLocationsToExcel = this.popupReportHistorialService.postLocationsVinListToExcel(this.filterLocationList).subscribe((data) =>{
      
  //       if (data.isSuccess == true) {
  //         // Decodificar los datos que trae como string del servidor
  //         const byteCharacters = atob(data.result);
  //         const byteNumbers = new Array(byteCharacters.length);
  //         for (let i = 0; i < byteCharacters.length; i++) {
  //           byteNumbers[i] = byteCharacters.charCodeAt(i);
  //         }
  //         const byteArray = new Uint8Array(byteNumbers);
  
  //         const blob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  //         const url = window.URL.createObjectURL(blob);
  //         const a = document.createElement('a');
  //         a.href = url;
  //         a.download = 'Lista_de_locacion.xlsx'; // Nombre del archivo según sea necesario
  //         document.body.appendChild(a);
  //         a.click();
  //         window.URL.revokeObjectURL(url);
  //         this.notifyService.MessageSuccessful(
  //           "Archivo Descargado",
  //           "Se han descargado los activos en un excel"
  //         );
  //       }
  //       else{
  //         this.notifyService.MessageError(
  //           "Archivo no descargado, No hay datos"
  //         );
  //       }
  //     });
  //   }
    
  // }

  // openFilter(): void {
  //   if(!environment.production) console.log("filtersObject",this.filtersObject);
    
  //   let dialogRef = this.dialog.open(FilterMapComponent, {
  //     data: { filters: this.filtersObject.filters, selected: this.filtersObject.selected },
  //     disableClose: true,
  //     width: "40vw",
  //     height: "fit-content",
  //     autoFocus: false,
  //     restoreFocus: false,
  //   });
  //  this.Subscription_AfterClosed = dialogRef.afterClosed().subscribe((res) => {
  //     if (res.search) {
  //       this.filterResponse.emit(res);
  //     }
  //   });
  // }

  getLocationRoute() {
    this.panelDetalilService.setLoading(true);
    this.subscription_findByIdentifier = this.locationService
          .findByIdentifier(this.identifier)
          .subscribe({
            next: (arg) => {
            if (this.identifier.length == 17) {
              this.locationRequest.vehiculo = arg.result[0];
              this.routeFilterService.setVehiculo( arg.result[0]);
            }
            if(!environment.production) console.log("buscando...");

            this.locationRequest.startDate = new Date();
            this.locationRequest.endDate = new Date();
            if(!environment.production) console.log("fechas inicio", this.locationRequest.startDate.toISOString());
            if(!environment.production) console.log("fechas fin", this.locationRequest.endDate.toISOString());
            if(!environment.production) console.log("request vehiculo identifier", this.locationRequest.vehiculo);
        
            if (
              this.locationRequest.vehiculo &&
              this.locationRequest.startDate &&
              this.locationRequest.endDate
            ) {
              try {
                const startDate = new Date(this.locationRequest.startDate);
                const endDate = new Date(this.locationRequest.endDate);
                startDate.setHours(this.locationRequest.startDate.getHours() - 6);
                endDate.setHours(this.locationRequest.endDate.getHours() - 6);
                var requestRouteMap: IRouteMapRequest = {
                  Identifier: this.locationRequest.vehiculo.identifier,
                  StartDate: this.locationRequest.startDate.toISOString(),
                  EndDate: this.locationRequest.endDate.toISOString(),
                  StartHour: null,
                };
        
                if(!environment.production) console.log("updating...");
        
                this.getRouteMapService(requestRouteMap);
              } catch (error) {
                // this.request.startDate = null;
                if(!environment.production) console.log(error);
                this.panelDetalilService.setLoading(false);
              }
            }else{
              this.panelDetalilService.setLoading(false);
            }
          },
          error: (error) => {
            // TODO marca para complete despues
            console.error('Error al buscar por identificador', error);
            this.panelDetalilService.setLoading(false);
          }
        });
    
  }

  getRouteMapService(routeMapRequest: IRouteMapRequest) {

    this.subscription_routeFilterService = this.routeFilterService.getRouteData(routeMapRequest).subscribe({
      next: (resp) => {
        if(!environment.production) console.log(resp);
        if (resp.isSuccess) {
          var resumeRoute = resp.result.resumeRouteMapDTO as ResumeRouteMapDTO;
          var detailsRoute = resp.result
            .detailsRouteDTO as StepDetailsRouteDTO[];
          var groupedRoute = resp.result
            .groupStepsRouteDTO as GroupStepRouteDTO[];
          if (resumeRoute != null) {
            
            if (resumeRoute.cantStops != null && resumeRoute.cantStops != "0" ) {
              //Close Locations
              this.panelDetalilService.setLoading(false);
              this.panelLocationsService.setVisibilityPanel(false);
              this.panelDetalilService.setVisibilityPopup(false);
              this.signalUserService.UnsubscribeSignalUserIdentifierService(this.identifier);
              this.mapHelper.UpdateLayerGeoJson(
                "locationActiveSource",
                this.mapHelper.Empty_GeoJson
              );

              //open routes
              this.routeMapService.showRouteMapLayers();
              this.panelResumeRouteService.setVisibilityPopup(true);
              this.panelResumeRouteService.setResume(resumeRoute);
              this.panelResumeRouteService.setDetails(detailsRoute);
              this.panelResumeRouteService.setGrouped(groupedRoute);
              if(!environment.production) console.log("groupedRoute", groupedRoute);
              this.mapHelper.SetBounds(JSON.parse(resumeRoute.sGeojsonResume));
              //this.panelResumeRouteService.setRequest(request);
              this.routeMapService.updateRouteMap(resumeRoute.sGeojsonResume);
            } else {
              
              this.panelDetalilService.setLoading(false);
              this.toastrService.info(
                "por favor acceda desde Rutas para filtrar por otro rango de fechas",
                "La Trazabilidad de Ruta para éste carro al día de ayer no fue encontrada"
              );
            }
          } else {
            
            this.panelDetalilService.setLoading(false);
            this.toastrService.info(
              "por favor acceda desde Rutas para filtrar por otro rango de fechas",
              "La Trazabilidad de Ruta para éste carro al día de ayer no fue encontrada"
            );
          }
        } else {
          this.panelDetalilService.setLoading(false);
          // this.toastrService.error("Internal Error", elements.errors.toString());
        }
      },
      error: (error) => {
        // TODO marca para complete despues
        console.error('Error al obtener los datos de la ruta', error);
        this.panelDetalilService.setLoading(false);
      }
    });
  }
 

  // onClickAddGeofence(){
  //   this.panelAddGeofenceService.$guidEditable = "";
  //   this.panelAddGeofenceService.$isDuplicate = false;
  //   this.geofenceService.setVisiblePanelGeofences(false);
  //   //seleccionar el panel de agregar geocerca
  //   this.geofenceService.setVisiblePanelEditGeofences(true);
  // }

  // onClickEditGeofence(){
  //   this.panelAddGeofenceService.$guidEditable = this.geofenceGuid;
  //   this.panelAddGeofenceService.$isDuplicate = false;
  //   this.geofenceService.setVisiblePanelGeofences(false);
  //   this.geofenceService.setVisiblePanelDetailGeofences(false);
  //   //seleccionar el componnte de edicion
  //   this.geofenceService.setVisiblePanelEditGeofences(true);
  // }

  // onClickDuplicateGeofence(){
  //   this.panelAddGeofenceService.$guidEditable = this.geofenceGuid;
  //   this.panelAddGeofenceService.$isDuplicate = true;
  //   this.geofenceService.setVisiblePanelGeofences(false);
  //   this.geofenceService.setVisiblePanelDetailGeofences(false);
  //   //seleccionar el componnte de edicion
  //   this.geofenceService.setVisiblePanelEditGeofences(true);
  // }

  // onClickDeleteGeofence(){
  //   var resp = this.notifyService.confirmMessage("Borrado","¿Seguro que desea borrar esta geocerca ?");
  //   resp.then((result) =>{
  //      if(result.value)
  //      {
  //         // window.open(urlb,'_blank');
  //         this.suscription_delete = this.geofenceService.delete(this.geofenceGuid).subscribe((data)=>{
  //           if(!environment.production) console.log("Data ",data);
  //           if(data.isSuccess == true){
  //             this.notifyService.MessageSuccessful("Borrado","Registro Borrado exitosamente");
  //             document.location.reload();
  //              }else{
  //             this.notifyService.MessageError("Problema al eliminar el registro");
  //              }
  //         });
  //       }
  //    }); 
  //   this.panelAddGeofenceService.$guidEditable = this.geofenceGuid;
  //   this.geofenceService.deleteGeofence(this.geofenceGuid);
  // }

  ValetParking(){
    if (this.isValetParking) {
      this.suscription_valetParkingDelete = this.geofenceService.FullDelete(this.valetParkingGuid).subscribe({
        next: (data) => {
        if(data.isSuccess == true){
          this.notifyService.MessageSuccessful("Borrado","Valet Parking Borrado exitosamente");
          this.valetParkingDeleteResponse.emit(true);
        }else{
          Sentry.captureMessage('ReportList.ValetParking: eliminación sin éxito', { level: 'warning', extra: { response: data } });
          this.notifyService.MessageError("Problema al eliminar el Valet Parking");
        }
      },
      error: (error) => {
        // TODO marca para complete despues
        console.error('Error al eliminar el valet parking', error);
        this.notifyService.MessageError("Error al eliminar el Valet Parking");
      }
    });
    }else{
      var dialog = this.valetParkingService.openDialog(this.identifier, this.description);
      dialog.afterClosed().subscribe((isCreated) => {
        if (isCreated)
          this.valetParkingCreateResponse.emit(isCreated);
      });
    }
  }

  openRecurrentPlaces(){
    this.geoClustersFrecuencyCatalogService.setRecurrentPlaces(!this.geoClustersFrecuencyCatalogService.isRecurrentPlacesVisible);
    if(this.geoClustersFrecuencyCatalogService.isRecurrentPlacesVisible){
      this.geoClustersFrecuencyCatalogService.identifierRecurrentPlaces = this.identifier;
      this.geoClustersFrecuencyCatalogService.descriptionRecurrentPlaces = this.description;
    }else{
      this.geoClustersFrecuencyCatalogService.identifierRecurrentPlaces = "";
      this.geoClustersFrecuencyCatalogService.descriptionRecurrentPlaces = "";
    }
  }

  hasReportsWithPermissions(): boolean {
    if (!this.showReportes) return false;
    
    if (this.isFromLocation) {
      return this.permissionFilterPipe.transform('Hist.Movimientos-L') || 
             this.permissionFilterPipe.transform('Habit.Conduccion-L') || 
             this.permissionFilterPipe.transform('Estad.Manejo-L');
    }
    
    if (this.isGlobal) {
      return this.permissionFilterPipe.transform('Hist.Global-L');
    }
    
    if (this.isRutas) {
      return this.permissionFilterPipe.transform('Hist.Movimientos-R') || 
             this.permissionFilterPipe.transform('Habit.Conduccion-R') || 
             this.permissionFilterPipe.transform('Estad.Manejo-R');
    }
    
    return false;
  }


  calculateRestrictions(){
    this.allowedParts = this.mapRestrictionsService.allowedParts$.value;
    this.isMovementHistoricalAllowed = this.allowedParts?.allowedFeaturesDetailsPanel?.includes(this.detailsPanelAllowanceEnum.movementReport);
    this.isDriverBehaviorAllowed = this.allowedParts?.allowedFeaturesDetailsPanel?.includes(this.detailsPanelAllowanceEnum.driveHabitsReport);
    this.isDriverStatisticsAllowed = this.allowedParts?.allowedFeaturesDetailsPanel?.includes(this.detailsPanelAllowanceEnum.driveStatisticsReport);
  }
}
